import {
  SAVE_JOBS_LIST,
  SAVE_JOB_DETAILS
} from 'redux/constants/Jobs';

const theme = (state = {}, action) => {
  switch (action.type) {
  case SAVE_JOBS_LIST:
    return {
      ...state,
      list: action.payload
    };
  case SAVE_JOB_DETAILS:
    return {
      ...state,
      details: action.payload
    };
  default:
    return state;
  }
};

export default theme